<div class="component-container xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]">
  <mat-expansion-panel
    [expanded]="true"
    class="mat-elevation-z0 expansion-panel w-full"
  >
    <mat-expansion-panel-header
      class="bg-black-100 expansion-panel-header justify-center"
    >
      <div class="title">
        <span *ngIf="groupInfo['startDate']">{{ groupInfo['startDate'] | date: 'fullDate' }},</span>&nbsp;Week Summary
      </div>
    </mat-expansion-panel-header>
    <div class="week-list-table">
      <app-week-list-table />
    </div>
  </mat-expansion-panel>
</div>
